import { useEffect, useState } from "react";
import PopupAlert from "../../components/PopupAlert";
import CreateUserPopup from "./CreateUserPopup";
import UpdateUserPopup from "./UpdateUserPopup";

const AdminUserComponent = ({ setShowNav, link }) => {
  const [deleteUser, setDeleteUser] = useState(false);

  const [userData, setUserData] = useState([]);

  const [createUser, setCreateUser] = useState(false);

  const [updateUser, setUpdateUser] = useState(false);

  const [userId, setUserId] = useState();

  const [singleUserData, setSingleUserData] = useState();

  const fetchUser = async () => {
    try {
      const response = await fetch(`${link}/all-users`, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
        },
      });

      const respData = await response.json();
      if (response.ok) {
        console.log("resp is :", respData.data);
        setUserData(respData.data);
      } else {
        alert(respData.message);
      }
    } catch (error) {
      console.log("error in fetching user data", error);
      alert("server error");
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  const handleDeleteUser = async () => {
    try {
      const response = await fetch(`${link}/delete-user/${userId}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        fetchUser();
      } else {
        alert("not ok");
      }
    } catch (error) {
      console.log("error in deleting user", error);
      alert("Server Error");
    }
    setDeleteUser(false);
  };

  //   :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

  return (
    <>
      {deleteUser ? (
        <div className="dboard-log-out-alert-n">
          <PopupAlert
            heading="Are you sure to delete user?"
            icon="fa-solid fa-trash-can"
            open={setDeleteUser}
            action={handleDeleteUser}
          />
        </div>
      ) : (
        ""
      )}
      {createUser ? (
        <CreateUserPopup
          open={setCreateUser}
          refreshList={fetchUser}
          link={link}
        />
      ) : (
        ""
      )}

      {updateUser ? (
        <UpdateUserPopup
          open={setUpdateUser}
          refreshList={fetchUser}
          userData={singleUserData}
          userId={userId}
          link={link}
        />
      ) : (
        ""
      )}

      <div className="goc-dashbord-right-side-main-head">
        <div>
          {" "}
          <span
            className="goc-dash-bord-menu-sm-open-ion"
            onClick={() => setShowNav(true)}
          >
            <i class="fa-solid fa-bars"></i>
          </span>{" "}
          Users
        </div>

        <div className="goc-dashbord-left-side-menu-log-out-button">
          <div onClick={() => setCreateUser(true)}>Create New User</div>
        </div>
      </div>

      <div className="goc-dashbord-main-show-data-warpper-row">
        <div className="goc-dashbord-leads-list-cotainer">
          <div className="goc-dashbord-leads-list-inner-cotainer goc-dashbord-user-list">
            <div className="goc-dashbord-leads-list-inner-header">
              <div>Name</div>
              <div>Email</div>
              <div>Business Access</div>
              <div>Days Access</div>
              <div>Delete</div>
              <div>Edit</div>
            </div>

            {/* sm-list  Header::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
            {/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::  */}

            <div className="wraper-goc-dashbord-leads-booking-main-small-header">
              <div className="wraper-goc-dashbord-leads-booking-small-header">
                <div>User</div>
                <div>Access</div>
              </div>
            </div>

            {userData &&
              userData.map((e) => (
                <>
                  <div className="goc-dashbord-leads-booking-list">
                    <div className="goc-dashbord-leads-booking-list-data">
                      <div className="goc-leads-booking-list-col">
                        <div>{e.name && e.name}</div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div> {e.email && e.email} </div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div>{e.companyAccess && e.companyAccess}</div>
                      </div>
                      <div className="goc-leads-booking-list-col">
                        <div>{e.dataAccessDays} days</div>
                      </div>

                      <div className="goc-leads-booking-list-col-edit">
                        <i
                          onClick={() => {
                            setDeleteUser(true);
                            setUserId(e._id);
                          }}
                          class="fa-solid fa-trash-can"
                        ></i>
                      </div>

                      <div className="goc-leads-booking-list-col-edit">
                        <i
                          onClick={() => {
                            setUpdateUser(true);
                            setUserId(e._id);
                            setSingleUserData(e);
                          }}
                          class="fa-solid fa-pen-to-square"
                        ></i>
                      </div>
                    </div>

                    {/* <div className="goc-leads-booking-list-col">
                    <div
                      className="goc-dashbord-share-leads-btn"
                      onClick={() => alert("true")}
                    ><i class="fa-solid fa-pen-to-square"></i>
                    </div>
                  </div> */}
                  </div>
                </>
              ))}
            {userData.length > 0 ? "" : <h2>No such users.</h2>}
            {/* sm-list :::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::: */}
            {/*::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::  */}
            {userData &&
              userData.map((e) => (
                <div className="goc-dashbord-leads-booking-small-list">
                  <div className="goc-dashbord-leads-booking-small-inner-list">
                    <div>
                      <div className="wraper-goc-dashbord-leads-booking-small-inner-list">
                        <div>
                          <div className="goc-leads-booking-list-col   sm-goc-leads-booking-list-col">
                            <div> {e.email && e.email} </div>
                            <div>{e.name && e.name}</div>
                          </div>
                        </div>
                        <div>
                          <div>
                            <div>{e.companyAccess && e.companyAccess}</div>
                            <div>{e.dataAccessDays} days</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="goc-dashbord-sm-share-leads-btn">
                    {" "}
                    <i
                      onClick={() => {
                        setDeleteUser(true);
                        setUserId(e._id);
                      }}
                      class="fa-solid fa-trash-can"
                    ></i>
                    <i
                      onClick={() => {
                        setUpdateUser(true);
                        setUserId(e._id);
                        setSingleUserData(e);
                      }}
                      class="fa-solid fa-pen-to-square"
                    ></i>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminUserComponent;
